import type { WithFields, WithIncludes } from "@/api/jsonapi";
import type { Job as _Job } from "@/api/raptor";
import { useGetAll } from "@mb-pro-ui/utils";

const fields = {
  jobs: ["accepted-ts", "created-ts", "own-status", "details"],
  "unit-statuses": ["state", "state-ts", "primary"],
} as const;

const include = { "own-status": {} } as const;

export type Job = WithIncludes<WithFields<_Job, typeof fields>, typeof include>;

export default function useJobs(enabled = true) {
  return useGetAll<Job>("raptor/jobs", {
    include,
    fields,
    sort: ["-created-ts"],
    retry: true,
    queryKey: ["allJobs"],
    enabled,
    refetchInterval: 15000,
  });
}
